import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="text-5xl font-bold text-black flex">
        <span className="animate-a">A</span>
        <span className="animate-s">S</span>
      </div>
    </div>
  );
};

export default Loader;
